import { render, staticRenderFns } from "./DatasetRowWidget.vue?vue&type=template&id=2cbd9dea&"
import script from "./DatasetRowWidget.vue?vue&type=script&lang=js&"
export * from "./DatasetRowWidget.vue?vue&type=script&lang=js&"
import style0 from "./DatasetRowWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports